import React from "react";
// import logo from "../../assets/images/logo.png";
import logo2 from "../../assets/images/new-logo-2.png";

function FooterHomeOne({ className }) {
  return (
    <>
      <section className={`appie-footer-area ${className || ""}`}>
        <div className="container">
          <div className="row">
            {/* Logo & Social Media */}
            <div className="col-lg-3 col-md-6">
              <div className="footer-about-widget">
                <div className="logo">
                  <a href="#">
                    <img src={logo2} alt="" />
                  </a>
                </div>
                <div className="social mt-30">
                  <ul>
                    <li>
                      <a
                        href="https://www.instagram.com/jitoyouthpune"
                        rel="noreferrer"
                        target="_blank"
                      >
                        <i className="fab fa-instagram" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Sports Venue Addresses */}
            <div className="col-lg-6 col-md-6">
              <div className="footer-navigation ">
                <h4 className="title">Sports Venue</h4>
                <ul className="d-flex flex-row flex-wrap gap-4">
                  <li className="flex-grow-1">
                    <strong>
                      <a href="https://goo.gl/maps/kUHgBfYcmisiJQdf9">
                        FLAME University
                      </a>
                    </strong>
                    <span>
                      Gat No. 1270, Lavale, Off. Pune Bengaluru Highway, Pune -
                      412115, Maharashtra, India.
                    </span>
                  </li>
                  <li className="flex-grow-1 mt-4">
                    <strong>
                      <a href="https://goo.gl/maps/NNCtnYJ3xM5YAk898">
                        Suyash Academy
                      </a>
                    </strong>
                    <span>
                      Bungalow 18 Chaitanya Soc, Flame Ring Road, Bhunde Vasti,
                      Bavdhan, Pune - 411021, Maharashtra, India.
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Contact Information */}
            <div className="col-lg-3 col-md-6">
              <div className="footer-widget-info">
                <h4 className="title">Get In Touch</h4>
                <ul>
                  <li className="d-flex align-items-center gap-2 text-nowrap">
                    <a href="tel:+919531455771">
                      <i className="fal fa-phone mr-2" />
                      <span>Aditya Lodha: </span>
                      <span className="ml-2"> +91 95617 55771</span>
                    </a>
                  </li>
                  <li className="d-flex align-items-center gap-2 mt-3 text-nowrap">
                    <a href="tel:+919890629114">
                      <i className="fal fa-phone mr-2" />
                      <span>Ayush Palesha: </span>
                      <span className="ml-2"> +91 98906 29114</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default FooterHomeOne;
